import { z } from 'zod';
import type {
    ListUpcomingUserAgreementsResponse,
    UpcomingUserAgreement,
} from '../legal-upcoming-user-agreements.types';
import { SystemDisplayTimeZoneSchema } from '../timezone.utils';
import { NonEmptyStringSchema } from './common.schemas';

export const UpcomingUserAgreementSchema: z.ZodType<UpcomingUserAgreement> = z
    .object({
        legal_document_uuid: z.string().uuid(),
        legal_document_title: NonEmptyStringSchema,
        takes_effect_ts: z.string().datetime(),
    })
    .strict();

export const ListUpcomingUserAgreementsResponseSchema: z.ZodType<ListUpcomingUserAgreementsResponse> =
    z
        .object({
            upcoming_user_agreements: z.array(UpcomingUserAgreementSchema),
            display_timezone: SystemDisplayTimeZoneSchema,
        })
        .strict();
